import { LoadingContainer } from '@ff-it/ui';
import { ReactElement } from 'react';
import useSWR from 'swr';
import { ListTask, TaskList } from '../types';
import { TasksContainer } from './TasksContainer';

type ObjectTaskListProps = {
  taskList: TaskList;
  onTaskListUpdate: (topic: TaskList) => void;
};

export function ObjectTaskList({ taskList, onTaskListUpdate }: ObjectTaskListProps): ReactElement {
  const url = `tasks/${taskList.object_key}/`;
  const { data: tasks, mutate, isLoading, error } = useSWR<ListTask[]>({ url });
  if (error) {
    throw error;
  }

  return (
    <LoadingContainer loading={isLoading}>
      {tasks && <TasksContainer tasks={tasks} url={url} onTaskListUpdate={onTaskListUpdate} mutate={mutate} />}
    </LoadingContainer>
  );
}
